import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import pages, { protectedPages } from './pages/pages';
import React, { Suspense, useEffect, useState } from 'react';
import Navbar from './Layout/Navbar/Navbar';
import Footer from './Layout/Footer/Footer';
import WPSAU from './components/Reuseables/WPSAU/WPSAU';
import Affiliates from './components/Reuseables/Affiliates/Affiliates';
import CQCSection from './components/Reuseables/Cqc/CQCSection';
// import Subscribe from './components/Reuseables/subsbcribe/Subscribe';
import AdminNavbar from './pages/Admin/Layout/Navbar/Navbar';
import ProtectedRoute from './pages/Auth/ProtectedRoutes';
import { useAuthCheck } from './components/Hooks/UseAuth';
import Form from './components/jobDetail/Form';
import Spinner from './components/Reuseables/Spinner/Spinner';
import BlogsDetail from './pages/BlogsDetail';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import CookieConsent from 'react-cookie-consent';
import Error404 from './pages/Error404/Error404';

// Layout wrapper for normal pages
const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const showAffiliates = pathname === '/' || pathname === '/about';
  const showCQCSection = pathname === '/' || pathname === '/about';

  return (
    <>
      {!pathname.includes('admin') && <Navbar />}
      {pathname.includes('admin') && <AdminNavbar />}

      {children}

      <WPSAU
        style={{
          display: pathname.includes('career') || pathname.includes('blogs') || pathname.includes('admin')
            ? 'none'
            : 'block',
        }}
      />
      {/* {(pathname.includes('career') || pathname.includes('blogs')) && <Subscribe />} */}
      {showCQCSection && <CQCSection />}
      {showAffiliates && <Affiliates />}
      <Footer />
    </>
  );
};

function App() {
  const { pathname } = useLocation();
  useAuthCheck();
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const location = useLocation();

  // scroll behavior for hash links
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offset = window.innerHeight / 70;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth',
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  // page loader effect
  useEffect(() => {
    setIsPageLoaded(false);
    const timeout = setTimeout(() => {
      setIsPageLoaded(true);
    }, 500);
    return () => clearTimeout(timeout);
  }, [pathname]);

  // check if this is the 404 page
  // const is404 = pathname === '*' || window.location.pathname === '/404'; 
  // we rely on Route path="*" so effectively any unmatched path means 404

  return (
    <div className="App">
      <ToastContainer />
      {isPageLoaded && (
        <Routes>
          {pages.map((page) => (
            <Route
              path={page.route}
              key={page.route}
              element={
                <Layout>
                  <Suspense fallback={<Spinner />}>
                    {page.element}
                  </Suspense>
                </Layout>
              }
            />
          ))}

          {protectedPages.map((page) => (
            <Route
              path={page.route}
              key={page.route}
              element={
                <ProtectedRoute>
                  <Layout>
                    <Suspense fallback={<Spinner />}>
                      {page.element}
                    </Suspense>
                  </Layout>
                </ProtectedRoute>
              }
            />
          ))}

          <Route
            path="career/:id/form"
            element={
              <Layout>
                <Form />
              </Layout>
            }
          />

          <Route
            path="/blogs/:id"
            element={
              <Layout>
                <Suspense fallback={<Spinner />}>
                  <BlogsDetail />
                </Suspense>
              </Layout>
            }
          />

          {/* 👇 bare 404, no layout */}
          <Route path="*" element={<Error404 />} />
        </Routes>
      )}

      {/* 👇 cookie banner shows everywhere EXCEPT 404 */}
      {!pathname.includes('404') && (
        <CookieConsent
          location="bottom"
          cookieName="lexraeCookieConsent"
          style={{
            background: "#29aae3",
            color: "#ffffff",
            padding: "15px",
            fontSize: "14px",
            boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.2)",
            animation: "slideUp 0.6s ease-out",
          }}
          buttonStyle={{
            color: "#29aae3",
            background: "#ffffff",
            fontSize: "14px",
            borderRadius: "5px",
            padding: "8px 15px",
            fontWeight: "bold",
            border: "none",
            cursor: "pointer",
            marginRight: "10px",
            transition: "all 0.3s ease",
          }}
          declineButtonStyle={{
            color: "#ffffff",
            background: "#f44336",
            fontSize: "14px",
            borderRadius: "5px",
            padding: "8px 15px",
            fontWeight: "bold",
            border: "none",
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
          buttonText="Accept"
          declineButtonText="Decline"
          enableDeclineButton
          onAccept={() => {
            console.log("User accepted cookies");
          }}
          onDecline={() => {
            console.log("User declined cookies");
          }}
        >
          We use cookies to improve your experience.{" "}
          <a
            href="https://docs.google.com/document/d/12dGT2T0daKIfny7O0TlBahMONYsRjyu0eVIGupnB50I/edit?usp=drivesdk"
            className="learn-more-link"
            style={{
              color: "#ffffff",
              textDecoration: "underline",
              fontWeight: "bold",
              transition: "color 0.3s ease, text-decoration-color 0.3s ease",
            }}
          >
            Learn more
          </a>

          <style>
            {`
              @keyframes slideUp {
                from {
                  transform: translateY(100%);
                  opacity: 0;
                }
                to {
                  transform: translateY(0);
                  opacity: 1;
                }
              }
              .CookieConsent button:hover {
                transform: scale(1.05);
                opacity: 0.9;
              }
              .learn-more-link:hover {
                color: #d0ebff;
                text-decoration-color: #d0ebff;
              }
            `}
          </style>
        </CookieConsent>
      )}
    </div>
  );
}

export default App;
